import React from 'react';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { JourneyFormik, JourneyForm } from 'src/common/JourneyFormik';
import { AutoSubmitForm } from '../auto-submit-form';
import * as Yup from 'yup';
import { NativeFormConfig } from '../store';
import { ToggleButton } from '../../components/dashboard/create-journey-modal';
import { FormikProps } from 'formik';
import {
  NeueHorizontalAlignCenterStrongIcon,
  NeueHorizontalAlignLeftStrongIcon,
  NeueHorizontalAlignRightStrongIcon,
} from 'src/monet/icons';

type NativeFormConfigBlockFormProps<T> = {
  onSubmit: (values: NativeFormConfig) => void;
} & T;

export const NativeFormConfigBlockForm = ({ onSubmit, ...props }: NativeFormConfigBlockFormProps<NativeFormConfig>) => {
  const formikParams = {
    initialValues: {
      title: props.title,
      description: props.description,
      submitButtonText: props.submitButtonText || 'Submit',
      submitButtonAlignment: props.submitButtonAlignment || 'left',
    },
    validationSchema: Yup.object({
      title: Yup.string(),
      description: Yup.string(),
      submitButtonText: Yup.string(),
      submitButtonAlignment: Yup.string().oneOf(['left', 'center', 'right']),
    }),
    onSubmit,
    validateOnChange: true,
  };

  return (
    <JourneyFormik {...formikParams}>
      {({ values, setFieldValue }: FormikProps<Record<string, string | boolean>>) => (
        <JourneyForm className='w-full flex flex-col gap-4 shrink-0'>
          <AutoSubmitForm />
          <FormikTextInput
            isNeue
            id='title'
            inputClasses='w-full'
            name='title'
            labelClassName='text-bedrock-p-strong text-neue-journey-fg'
            required
            type='text'
            label='Title'
            autoFocus
          />
          <FormikTextInput
            isNeue
            inputClasses='w-full'
            id='description'
            name='description'
            labelClassName='text-bedrock-p-strong text-neue-journey-fg'
            required
            type='text'
            label='Description'
          />
          <div className='flex flex-col gap-2'>
            <span className='text-bedrock-p-strong text-neue-journey-fg'>Submit button</span>
            <FormikTextInput
              isNeue
              id='submitButtonText'
              inputClasses='w-full'
              name='submitButtonText'
              labelClassName='text-bedrock-p-strong text-neue-journey-fg'
              required
              type='text'
              placeholder='Button label'
            />
            <div className='flex gap-2 items-center justify-center'>
              <ToggleButton
                selected={values.submitButtonAlignment === 'left'}
                label={<NeueHorizontalAlignLeftStrongIcon className='w-4 h-4' />}
                onClick={() => {
                  setFieldValue('submitButtonAlignment', 'left');
                }}
              />
              <ToggleButton
                selected={values.submitButtonAlignment === 'center'}
                label={<NeueHorizontalAlignCenterStrongIcon className='w-4 h-4' />}
                onClick={() => {
                  setFieldValue('submitButtonAlignment', 'center');
                }}
              />
              <ToggleButton
                selected={values.submitButtonAlignment === 'right'}
                label={<NeueHorizontalAlignRightStrongIcon className='w-4 h-4' />}
                onClick={() => {
                  setFieldValue('submitButtonAlignment', 'right');
                }}
              />
            </div>
          </div>
        </JourneyForm>
      )}
    </JourneyFormik>
  );
};
